export default function path(root, sublink) {
  return `${root}${sublink}`;
}
